import { translate } from 'support/translate';
import AbstractModal from 'components/widgets/AbstractModal';

export default class AyswModal extends AbstractModal {
  override _setup() {
    this.bgAlpha = 0.9;
    this.bgColor = 'black';
    this.confirmLabel = translate('global.continue');
  }
}
